(function () {
    'use strict';

    const CONFIG = {
        debug: false,
    };

    function debugLog(message, data = null) {
        if (CONFIG.debug) {
            console.log('[Infinite Slider]', message, data || '');
        }
    }

    document.addEventListener('DOMContentLoaded', function () {
        const instafeedContainer = document.querySelector('section[id$="_instagram"]');
        debugLog('instafeedContainer', instafeedContainer);

        if (instafeedContainer) {
            const observer = new MutationObserver((mutationsList) => {
                debugLog('mutationsList', mutationsList);

                for (const mutation of mutationsList) {
                    if (mutation.addedNodes && mutation.addedNodes.length > 0) {
                        var instafeed = document.querySelector('.instafeed-new-layout-wrapper');

                        if (instafeed && instafeed !== instafeedContainer) {
                            const istafeedPopultes = instafeed.childNodes !== null || instafeed.childNodes.length > 0;

                            if (istafeedPopultes) {
                                observer.disconnect();

                                debugLog('Instafeed already populated', instafeed.childNodes.length);
                                updateInstafeed();

                                return;
                            }
                            observer.observe(instafeed, { childList: true, subtree: true });
                        }
                    }
                }
            });

            observer.observe(instafeedContainer, { childList: true, subtree: true });
        }
    });

    function updateInstafeed() {
        const link = document.querySelector('.instafeed-bottom-link-wrapper');

        if (link && link.parentNode) {
            link.parentNode.insertBefore(link, link.parentNode.firstChild);
            debugLog('Moved link to be the first child of its parent');
        }


    }

    debugLog('Script customizado inicializado');
})();

